import type { ThemeConfig } from 'antd';

// Shared Ant Design theme. RTL direction + Persian locale are applied on <ConfigProvider> in main.tsx.
export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#1677ff',
    borderRadius: 6,
    fontFamily:
      "Vazirmatn, Tahoma, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  components: {
    Layout: {
      headerBg: '#001529',
      siderBg: '#001529',
    },
  },
};
